import React from 'react';
import {
    Input,
    Select,
    Icon
} from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <div className="row">
                    
                    <div className="col-md-3">
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombreChofer} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombreChofer", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
        );
    }

}

export default Filters;